/**
 * JS mirror of Ppk2\Profile\NickRules (src/NickRules.php) for instant feedback.
 * Keep both in sync. The server always re-checks.
 */
export const MIN_LENGTH = 2;
export const MAX_LENGTH = 24;
export const SPECIAL_CHARS = '_ ( ) { } @ # $ % + - *';
export const KEY = 'ppk2-profile.lib.nick.';
const ALLOWED_CHAR = /^[A-Za-zÄÖÅäöå0-9 _(){}@#$%+\-*]$/u;
const FIRST_CHAR = /^[A-Za-zÄÖÅäöå_$]/u;
const ROLE_SUFFIX = /\((?:C|A)\)$/iu;
export function normalize(value) {
  if (value === null || value === undefined) return null;
  const v = String(value).replace(/^[\s\p{Z}]+|[\s\p{Z}]+$/gu, '');
  return v === '' ? null : v;
}
export function displayChar(ch) {
  if (/^[\s\p{Z}\p{C}]$/u.test(ch)) {
    return 'U+' + ch.codePointAt(0).toString(16).toUpperCase().padStart(4, '0');
  }
  return ch;
}

/** @returns {[string, object] | null} [translation key, params] of the first problem */
export function check(nick) {
  const chars = Array.from(nick);
  if (chars.length < MIN_LENGTH) return [KEY + 'too_short', {
    min: MIN_LENGTH
  }];
  if (chars.length > MAX_LENGTH) return [KEY + 'too_long', {
    max: MAX_LENGTH
  }];
  for (const ch of chars) {
    if (!ALLOWED_CHAR.test(ch)) return [KEY + 'invalid_char', {
      char: displayChar(ch)
    }];
  }
  if (!FIRST_CHAR.test(nick)) return [KEY + 'bad_first_char', {}];
  if (ROLE_SUFFIX.test(nick)) return [KEY + 'suffix_forbidden', {}];
  return null;
}
flarum.reg.add('ppk2-profile', 'forum/utils/nickRules', { MIN_LENGTH: MIN_LENGTH,MAX_LENGTH: MAX_LENGTH,SPECIAL_CHARS: SPECIAL_CHARS,KEY: KEY,normalize: normalize,displayChar: displayChar,check: check, });